import {
  ApiWebhookEventData,
  IWebhookEvent,
  WebhookEventStatus,
} from '@principle-theorem/principle-core/interfaces';
import { toTimestamp } from '@principle-theorem/shared';

export class WebhookEvent {
  static init(
    eventData: ApiWebhookEventData,
    overrides?: Partial<Omit<IWebhookEvent, 'eventType' | 'data'>>
  ): IWebhookEvent {
    return {
      timestamp: toTimestamp(),
      status: WebhookEventStatus.Pending,
      retryAttempts: 0,
      ...eventData,
      ...overrides,
    };
  }
}
